// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import { CREATE_SETTING_GOAL, GET_GOAL } from '~/utils/constants/actionType';
import { IFormSettingGoal } from '~/utils/interface/goal';
import settingGoalApi from '~/apis/goal';

export const getDetailGoal = createAsyncThunk(GET_GOAL, async (_, { rejectWithValue }) => {
  try {
    const resp = await settingGoalApi.getDetailGoal();
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createSettingGoal = createAsyncThunk(
  CREATE_SETTING_GOAL,
  async (body: IFormSettingGoal, { rejectWithValue }) => {
    try {
      const resp = await settingGoalApi.createSettingGoal(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
